import { SvgIcon, SvgIconProps } from '@mui/material'

export function ManualQuestionIcon(props: SvgIconProps) {
  return (
    <SvgIcon role="img" viewBox="0 0 16 16" {...props}>
      <g clipPath="url(#a)" fillRule="evenodd" clipRule="evenodd">
        <path
          d="M2.932 2.933A7.146 7.146 0 0 1 8 .833c1.979 0 3.771.803 5.068 2.1l-.354.353.354-.353A7.146 7.146 0 0 1 15.167 8a7.146 7.146 0 0 1-2.1 5.068A7.146 7.146 0 0 1 8 15.167a7.146 7.146 0 0 1-5.068-2.1l.354-.353-.354.354A7.146 7.146 0 0 1 .833 8c0-1.979.803-3.771 2.1-5.067ZM8 1.833c-1.703 0-3.244.69-4.36 1.807A6.146 6.146 0 0 0 1.832 8c0 1.703.69 3.244 1.806 4.36A6.146 6.146 0 0 0 8 14.168c1.704 0 3.245-.69 4.361-1.806A6.146 6.146 0 0 0 14.167 8c0-1.704-.69-3.245-1.807-4.361A6.146 6.146 0 0 0 8 1.833Z"
          fill="currentColor"
        />
        <path
          d="M5.5 6.208a2.5 2.5 0 1 1 3 2.45v.884a.5.5 0 0 1-1 0V8.209a.5.5 0 0 1 .5-.5 1.5 1.5 0 1 0-1.5-1.5.5.5 0 0 1-1 0Z"
          fill="currentColor"
        />
        <path
          d="M8 12.542a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667Z"
          fill="#1C1B1E"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </SvgIcon>
  )
}

export default ManualQuestionIcon
